import { FormKitNode } from "@formkit/core";
import { isValidPhoneNumber as externalIsValidPhoneNumber } from "libphonenumber-js";

export const isValidPhoneNumber = (node: FormKitNode) => {
  if (!node.value) {
    return false;
  }

  // await node.input(new AsYouType().input(node.value as string));

  try {
    return externalIsValidPhoneNumber(node.value as string);
  } catch (err) {
    console.warn("Could not parse", err);
    return false;
  }
};
